import type { Color } from 'three';
import { ColorRepresentation } from '../types/color';
import { TranslateOptions, ColorState } from '../types/animations';
import { gsap } from 'gsap';
import { TimelineExt, TimelineWithPosition } from '../utils/combine';

export function translateColor(colors: Color | Color[], options?: TranslateOptions<ColorState>): gsap.core.Timeline;
export function translateColor(colors: Color | Color[], options: TranslateOptions<ColorState>, position: gsap.Position): TimelineWithPosition;
export function translateColor(_colors: Color | Color[], options?: TranslateOptions<ColorState>, position?: gsap.Position): TimelineExt {
    const colors = (Array.isArray(_colors) ? _colors : [_colors]).filter(Boolean);

    if (!colors.length) {
        // eslint-disable-next-line no-console
        console.warn('translateColor: no supported materials found', colors);
        return null;
    }

    const { tl: existingTl, from, to, vars, timelineVars, reset = false } = options || { };

    const fromColor = from?.color && ColorRepresentation.parse(from.color);
    const toColor = to?.color && ColorRepresentation.parse(to.color);

    if (reset && fromColor) {
        colors.forEach(c => {
            c.r = fromColor.r;
            c.g = fromColor.g;
            c.b = fromColor.b;
        });
    }

    const tl = existingTl ?? gsap.timeline(timelineVars);

    if (toColor) {
        const t = ColorRepresentation.clone(toColor);
        if (fromColor) {
            const f = ColorRepresentation.clone(fromColor);
            tl.fromTo(
                colors,
                f,
                { ...t, ...vars },
                0,
            );
        } else {
            tl.to(
                colors,
                { ...t, ...vars },
                0,
            );
        }
    }

    if (position !== undefined) {
        return { tl, position };
    }

    return tl;
}
